export function addCurrent(config) {
    return {
        type: 'ADD_CURRENT_CONFIG',
        config,
    }
}
